import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ErrorService } from '@app/services/error.service';
import { catchError } from 'rxjs/operators';

export const CUSTOMER_IDENTITY_SERVICE_API_ROOT = '/customer-identity/v1/customer-identity';

@Injectable()
export class CustomerIdentityService {

    private errors;

    constructor(
        private http: HttpClient,
        private errorService: ErrorService,
    ) {
        this.errors = this.errorService.userServiceErrors;
    }

    public requestPasswordReset(userId: string): Observable<object | null> {
        return this.http.post<object>(`${CUSTOMER_IDENTITY_SERVICE_API_ROOT}/${userId}/password-reset`, {}).pipe(
            catchError(this.errorService.errorHandler(this.errors, 'Réinitialisation d\'un mot de passe', null))
        );
    }
}
